export const LANG_SETTING = {
    ru: {
        SelectDate: `Выберите дату`,
        From: `От`,
        NoPlaces: `Нет мест`,
        Apartments: `квартиры`,
        Busy: `Занято`,
        Booking: `Забронировать`,
        MapShow: `Посмотреть квартиры на карте`,
        MapClose: `Свернуть карту`,

    },
    en: {
        SelectDate: `Select date`,
        From: `From`,
        NoPlaces: `No places`,
        Apartments: `apart.`,
        Busy: `Busy`,
        Booking: `Book now`,
        MapShow: `View apartments on the map`,
        MapClose: `Collapse map`,
    },
};

